<script>
export default {
  name: 'ProInput',
  props: {
    value: {
      required: true,
    },
    options: {
      default: {},
    },
  },
  watch: {
    input (input) {
      this.$emit('input', input)
    },
    value (newValue) {
      this.input = newValue
    },
  },
  data () {
    return {
      input: null,
      focused: false,
      entered: false,
    }
  },
  computed: {
    isActive () {
      return this.focused || this.input
    },
    isDate () {
      return this.options.type === 'date'
    },
    isTime () {
      return this.options.type == 'time'
    },
    placeholderCopy () {
      return (this.entered && this.error) ? this.error : this.options.title
    },
    error () {
      return this.options.errorIf && this.options.errorIf(this.input)
    },
    style () {
      return this.options.style || {}
    },
  },
  methods: {
    handleKey (e) {
      if (e.code === 'Enter') {
        this.options.onEnter && this.options.onEnter()
      }
      this.options.onKey && this.options.onKey()
    },
    onFocus () {
      this.focused = true
      if (this.options.onFocus) {
        this.options.onFocus()
      }
    },
    onBlur (input) {
      const onBlurFunc = this.options.onBlur
      onBlurFunc && onBlurFunc(input)
    }
  },
  mounted () {
    // set value if one is passed in
    if (this.value) this.input = this.value
  }
}
</script>

<template lang="pug">
  .pro-input-main
    .pro-input-container(
      :class='options.containerClass'
    )
      .input-holder(
        :class='error && entered ? "error" : ""'
      )
        template(
          v-if='["checkbox"].includes(options.type)'
        )
          .checkbox-area(
            v-if='options.type === "checkbox"'
            @click='$emit("input", !input)'
          )
            .checkbox
              i.material-icons {{input ? 'check_box' : 'check_box_outline_blank'}}
            .prompt {{options.prompt}}
        template(
          v-else
        )
          .placeholder(
            :class='isActive || isDate || isTime ? "active" : ""'
          ) {{placeholderCopy}}
          input(
            v-if='options.type === "number"'
            type='number'
            v-model='input'
            @keydown='handleKey'
            @focus='onFocus'
            @blur='focused = false;entered = true'
          )
          textarea(
            ref='textarea'
            v-else-if='options.type === "textarea"'
            v-model='input'
            @keydown='handleKey'
            @focus='focused = true'
            @blur='focused = false;entered = true'
            :style='{height: options.height || "100px", ...style}'
          )
          input(
            v-else-if='options.type === "password"'
            type='password'
            v-model='input'
            @keydown='handleKey'
            @focus='onFocus'
            @blur='focused = false;entered = true'
          )
          input(
            v-else-if='isDate'
            type='date'
            v-model='input'
            @keydown='handleKey'
            @focus='onFocus'
            @blur='focused = false;entered = true'
          )
          input(
            v-else-if='isTime'
            type='time'
            v-model='input'
            @keydown='handleKey'
            @focus='onFocus'
            @blur='focused = false;entered = true'
          )
          input(
            v-else
            v-model='input'
            @keydown='handleKey'
            @focus='onFocus'
            @blur='focused = false;entered = true;onBlur(input)'
          )
</template>

<style lang="sass" scoped>
  @import '$vars'
  .pro-input-main
    .pro-input-container
      .input-holder
        position: relative
        margin-top: 5px
        padding-bottom: 8px
        &.error
          .placeholder
            color: red !important
          > input
            border-bottom-color: red
            &:focus
              border-bottom-color: red !important
        .checkbox-area
          display: grid
          grid-template-columns: 2rem auto
          align-items: center
          cursor: pointer
          user-select: none
        .placeholder
          user-select: none
          position: absolute
          bottom: 24px
          color: #BBB
          transition: all .25s
          font-size: 16px
          //font-family: $font-2
          &.active
            font-size: .7em
            bottom: 48px
            //top: -12px
            color: #AAA
        > input
          background-color: transparent
        > textarea
          width: 100%
          box-sizing: border-box
          resize: none
          padding: 8px
          background-color: white
          border-radius: .5rem
        > input , > textarea
          margin-bottom: 0
          height: 2rem
          z-index: 1
          position: relative
          padding-bottom: 7px
          color: #000
          border: none
          border-bottom: thin black solid
          width: 100%
          font-family: $font-1
          font-size: 16px
          &:focus
            transition: .25s all
            border-bottom: 1px solid black !important
            box-shadow: none !important
            color: #000
            outline: none

</style>
